export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    if ($('select#product__variation_id').length > 0) {
      var selectedId = $('select#product__variation_id').children('option:selected').val();
      var newQueryString = '/cart/?add-to-cart=' + selectedId;
      $('.add_to_cart_button').attr('href', newQueryString)

      $('select#product__variation_id').change(function(){
        var selectedId = $(this).children('option:selected').val();
        var newQueryString = '/cart/?add-to-cart=' + selectedId;
        $('.add_to_cart_button').attr('href', newQueryString)
      });
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js